import {addClass, findID, hasClass, listener, removeClass} from "../../../../../../modules/vegas/js/util";

function listeners() {
	listener('click', '[data-vg-toggle="categories"]', function (el, e) {
		e.preventDefault();

		if (hasClass(el, 'active')) {
			removeClass(el, 'active');
		} else {
			addClass(el, 'active');
		}

		let dropdown = findID(el.getAttribute('href').slice(1));
		if (dropdown) {
			if (hasClass(dropdown, 'show')) {
				removeClass(dropdown, 'show');
			} else {
				addClass(dropdown, 'show');
			}
		}
	});

	listener('mouseup', '*', (el, e) => {
		let dropdown = findID('header-categories');
		if (!dropdown) return;

		if (
			!e.target?.closest('[data-vg-toggle="categories"]')
			&& !e.target.closest('.header-categories-wrapper')
			&& dropdown.classList.contains('show')
		) {
			dropdown.classList.remove('show');
			document.querySelector('[data-vg-toggle="categories"]')?.classList.remove('active');
		}
	});
}

document.addEventListener("DOMContentLoaded", listeners);
